import { getClient } from '@zg-rentals/ts-client-http-client';

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Shared HTTP client for calls to the Zillow Group / rental-manager-api backend.
 * In dev, NEXT_PUBLIC_ZG_API_PUBLIC points at the same-origin proxy (src/middleware.ts, next.config.ts) rather than the backend directly, to avoid CORS.
 */
export const client = getClient().extend({
  prefixUrl: process.env.NEXT_PUBLIC_ZG_API_PUBLIC,
  credentials: isDevelopment ? 'include' : undefined,
  headers: {
    'x-build-id': String(process.env.NEXT_PUBLIC_BUILD_NUMBER),
  },
});

/** Same as `client` but with a longer timeout, for large uploads (photos, floor plan layouts). */
export const slowClient = client.extend({ timeout: 3 * 60 * 1000 });
